module.exports = "/_next/static/images/e8121ed80e58a5fa351584e7596cbbfe-custom-arrow.svg.webp";